const RESET_PASSWORD = {
    EMAIL_CODE: "ucs/api/v1/user-token/forget-email",//往郵箱發送驗證碼
    RESET: "ucs/api/v1/passwords/reset",//忘記密碼-郵箱重置密碼
    CENTER_RESET:"ucs/api/v1/private/password",//個人中心-更改密碼
}
export default RESET_PASSWORD